<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': loginLogs.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Registry of Login') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th class="text-nowrap" scope="col">{{ i18n('User') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Result') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Date') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Application') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('IP') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Access origin') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <AuditLoginListItem v-for="loginLog in loginLogs" :loginLog="loginLog" :key="loginLog.id"
            @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" />
          <EmptyListItem v-if="!loginLogs || loginLogs.length == 0" :loading="loading" :colspan="5" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad" :colspan="5" @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
    <Pagination cssClass="mt-2" v-if="pagination && pagination.singlePage && pagination.limit < pagination.total"
      :pagination="pagination" :loading="loading" @goToPage="(...args) => $emit('goToPage', ...args)" />
  </div>
</template>

<script>
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Pagination from "@/components/common/list/Pagination.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";
import AuditLoginListItem from "@/components/auditLogin/AuditLoginListItem.vue";

export default {
  components: {
    EmptyListItem,
    LazyLoadListItem,
    Pagination,
    Tooltip,
    AuditLoginListItem,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
    'goToPage',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    pagination: Object,
    loginLogs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
  },
};
</script>